module.exports = __webpack_public_path__ + "static/media/15.394fdb8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/15.png
// module id = 1256
// module chunks = 0